/**
 * Cómo se enseña una gestión (assignment) al cliente (27/10/2026): sin los
 * nombres internos del sistema.
 */

/** «AI Agent» es el usuario interno del agente: al cliente se le dice «IA». */
export const assigneeName = assignee => {
  if (!assignee) return '';
  const nombre = [assignee.username, assignee.userlastname].filter(Boolean).join(' ').trim();
  return /^AI ?Agent$/i.test(nombre) ? 'IA' : nombre;
};

/**
 * La nota que deja el sistema al crear una gestión por una interacción
 * («Creado automáticamente por interacción whatsapp_response») no le dice nada
 * al cliente: la descripción ya lo cuenta.
 */
export const visibleNotes = notes =>
  notes && !/^Creado automáticamente por interacción/i.test(String(notes).trim()) ? notes : '';
